"use client"

import type React from "react"
import { useMemo } from "react"
import { useAuth } from "../../../context/AuthContext"
import { useUserMenu } from "../../../hooks/useUserMenu"
import { useMobileMenu } from "../../../hooks/useMobileMenu"
import { createNavItems } from "../../../constants/header"
import type { HeaderProps } from "../../../types/header"

// Components
import Logo from "./Logo"
import DesktopNavigation from "./DesktopNavigation"
import MobileMenuButton from "./MobileMenuButton"
import MobileNavigation from "./MobileNavigation"

import "./Header.css"

const Header: React.FC<HeaderProps> = ({ onDemoClick }) => {
  const { user, isAuthenticated } = useAuth()
  const { isMenuOpen, toggleMenu, closeMenu } = useMobileMenu()
  const { showUserMenu, userMenuRef, toggleUserMenu, userMenuActions } = useUserMenu()

  // Memoize navigation items to prevent recreation on every render
  const navItems = useMemo(() => createNavItems(onDemoClick), [onDemoClick])

  return (
    <header className="header">
      <nav className="nav">
        <div className="nav-container">
          <Logo />

          <DesktopNavigation
            navItems={navItems}
            isAuthenticated={isAuthenticated}
            user={user}
            showUserMenu={showUserMenu}
            onToggleUserMenu={toggleUserMenu}
            userMenuActions={userMenuActions}
            userMenuRef={userMenuRef}
          />

          <MobileMenuButton isOpen={isMenuOpen} onToggle={toggleMenu} />
        </div>

        <MobileNavigation
          navItems={navItems}
          isAuthenticated={isAuthenticated}
          isOpen={isMenuOpen}
          onClose={closeMenu}
        />
      </nav>
    </header>
  )
}

export default Header
